import toast from "react-hot-toast";
import { connect } from "react-redux";
import React, { useEffect, useState } from "react";
import Style from "./ProfileDocNumber.scss";
import Log from "laravel-mix/src/Log";

const ProfilDocNumber = ({ lastDocNumber, updateLastDocNumber }) => {
   const [docNumber, setDocNumber] = useState("");

   useEffect(() => {
      lastDocNumber ? setDocNumber(lastDocNumber) : null;
   }, [lastDocNumber]);
   const handleDocNumberChange = (e) => {
      //   if (/[^0-9]/.test(e.target.value)) {
      //      toast.error("Votre saisie n'est pas uniquement numérique !");
      //      return false;
      //   }

      if (!/^[a-zA-Z]?\d*$/.test(e.target.value)) {
         toast.error("Votre saisie doit soit contenir une lettre suivie de chiffres, soit uniquement des chiffres !");
         return false;
      }
      if (e.target.value.length > 5) {
         toast.error("Vous ne pouvez pas entrer plus de 5 caractères !");
         return false; // Arrête la fonction si la saisie dépasse 5 caractères
      }

      setDocNumber(e.target.value);
      updateLastDocNumber(e.target.value);
      toast.success("Actualisation de vos données de structure réussie");
      e.preventDefault();
   };

   return (
      <div className="d-flex flex-column justify-content-start align-items-center p-3 w-100">
         <div className={"w-100 font-weight-bold text-left my-2"}>Inscrivez votre dernier N° de dossier</div>
         <div
            className={"d-flex justify-content-center align-items-center w-100 p-2 ue-docnumber-wrapper"}
            style={{ backgroundColor: "var(--theme-gray-bg-input)" }}
         >
            <div className="d-flex flex-column justify-content-center align-items-center ue-docnumber-xx ">
               <h1>CU</h1>
               <div>type</div>
            </div>
            <div className="d-flex flex-column justify-content-center align-items-center ue-docnumber-xx ">
               <h1>XX</h1>
               <div>dept</div>
            </div>
            <div className="d-flex flex-column justify-content-center align-items-center ue-docnumber-xx ">
               <h1>XXXXX</h1>
               <div>INSEE</div>
            </div>
            <div className="d-flex flex-column justify-content-center align-items-center ue-docnumber-xx ">
               <h1>XX</h1>
               <div>année</div>
            </div>
            {/* <div className="d-flex flex-column justify-content-center align-items-center ue-docnumber-xx ">
               <input
                  type={"text"}
                  className="form-control ue-docnumber"
                  style={{ width: "100px" }}
                  id="doc_number"
                  name="doc_number"
                  value={docNumber}
                  onChange={handleDocNumberChange}
               />
               <div className={"font-weight-bold"}>N° DOSSIER</div>
            </div> */}

            <div className="d-flex flex-column justify-content-center align-items-center">
               <div
                  style={{
                     position: "relative",
                     width: "100px",
                     height: "50px",
                     display: "flex",
                     justifyContent: "center",
                     alignItems: "center",
                  }}
                  className="ue-docnumber-xx "
               >
                  <div style={{ position: "absolute", top: "50%", right: "32", transform: "translateY(-50%)" }}>
                     {Array.from({ length: 5 - (docNumber || "").length }, (_, index) => (
                        <span key={index} style={{ fontSize: "2em", opacity: "0.5" }}>
                           X
                        </span>
                     ))}
                  </div>
                  <input
                     type={"text"}
                     className="form-control ue-docnumber"
                     style={{
                        width: "100px",
                        zIndex: "1",
                        backgroundColor: "transparent",
                        border: "none",
                        textAlign: "left",
                        fontSize: "2em",
                     }}
                     id="doc_number"
                     name="doc_number"
                     value={docNumber}
                     onChange={handleDocNumberChange}
                  />
               </div>
               <div className={"font-weight-bold"}>N° DOSSIER</div>
            </div>
         </div>
      </div>
   );
};

const mapStateToProps = (state) => {
   return {
      userId: state.MeReducer.id,
      entity: state.MeReducer.entity,
      username: state.MeReducer.username,
      lastDocNumber: state.MeReducer.lastDocNumber,
      role: state.MeReducer.role,
      types: state.SubscribtionReducer.types,
      structureInfo: state.SubscribtionReducer.structureInfo,
   };
};

const mapDispatchTProps = (dispatch) => {
   return {
      updateLastDocNumber: (e) => dispatch({ type: "UPDATE_LAST_DOC_NUMBER", data: e }),
   };
};

export default connect(mapStateToProps, mapDispatchTProps)(ProfilDocNumber);
